import { Heading2, Heading3 } from '@/components/base/Heading'
import spaceStyle from '@/styles/space'
import { Text4 } from '@/components/base/Text'
import { align } from '@/styles/display'
import { useApp } from '@/hooks/useApp'

interface Props {
  title: string
  smallTitle?: string
  isCard?: boolean
  maxLines?: number
}

const JobPostingTitleComponent = ({
  title,
  smallTitle,
  isCard, // TODO: <デザイン相談>下記参照
  maxLines
}: Props): JSX.Element => {
  const app = useApp()
  return (
    <>
      {isCard ?? false ? (
        /**
         * TODO: <デザイン相談>標準コンポーネントのデザインにできないか後で相談
         * - JobPotingCardの時は14px
         *  https://www.figma.com/file/RiD0EJt6IYzuWUktzwAkdV/Myrecruiter-Master-File?node-id=1473-24480&t=eSLZFSRqjwZLeGdw-4
         * - 求人詳細では16px
         *  https://www.figma.com/file/RiD0EJt6IYzuWUktzwAkdV/Myrecruiter-Master-File?node-id=94-14805&t=eSLZFSRqjwZLeGdw-4
         */
        <Heading3
          fixedSPfontSize
          margin={{ all: spaceStyle.XS }}
          textAlign={align.LEFT}
          maxLines={maxLines}
        >
          {title}
        </Heading3>
      ) : (
        <Heading2
          fixedSPfontSize
          margin={{ all: spaceStyle.XS }}
          maxLines={maxLines}
        >
          {title}
        </Heading2>
      )}
      {smallTitle !== undefined && (
        <Text4
          margin={{ all: spaceStyle.XS }}
          textAlign={align.LEFT}
          textColor={app.theme.subTextColor}
          maxLines={maxLines}
        >
          {smallTitle}
        </Text4>
      )}
    </>
  )
}

export default JobPostingTitleComponent
